module.exports = __webpack_public_path__ + "media/images/flags/1x1/wal-f4559a95e44275867bf40f99acba3c64.svg";